// extracted by mini-css-extract-plugin
export var box = "_1q-1";
export var checkboxRow = "_1q-8";
export var checked = "_1q-2";
export var descriptionSpacer = "_1q-a";
export var disabled = "_1q-3";
export var icon = "_1q-6";
export var input = "_1q-0";
export var labelSpacer = "_1q-9";
export var medium = "_1q-5";
export var small = "_1q-4";
export var text = "_1q-7";